/**
 *
 * QuestionnaireSection
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  accentColorPrim,
  accentColorSecond,
  red,
  white,
} from '../../../../assets/styledAssets/vars';
import { Wrap } from '../../../../assets/styledAssets/grid';
import { StyledTransparentInput } from '../QuestionnaireEdit/styles';
import { Input } from '@progress/kendo-react-inputs';
import Button from '../../../../components/Button/Button.component';
import {
  CopyIcon,
  DeleteIcon,
} from '../../../../components/Icons/Icons.component';
import { QuestionSeries } from '../../questionnaires';
import {
  editSection,
  addQuestion,
  removeSection,
  copySection,
} from '../../Questionnaires.slice';
import RightActions from '../RightActions/RightActions.component';
import { SectionWrap } from './styles';
import { addSection } from '../../Questionnaires.actions';

interface IProps {
  series: QuestionSeries;
  index: number;
  total: number;
  editSection: typeof editSection;
  addSection: typeof addSection;
  addQuestion: typeof addQuestion;
  removeSection: typeof removeSection;
  copySection: typeof copySection;
}

const QuestionnaireSection: FunctionComponent<IProps> = ({
  series,
  index,
  total,
  editSection,
  addSection,
  addQuestion,
  removeSection,
  copySection,
}) => {
  const intl = useIntl();
  return (
    <SectionWrap>
      <Wrap
        br={'1rem'}
        bgColor={accentColorPrim}
        flexDir={'column'}
        flexWrap={'nowrap'}
        width={'calc(100% - 6rem)'}
        margin={'0 0 3rem 0'}
        id={`section-${index}`}
      >
        <Wrap color={white} fs={'2.4rem'} padding={'2rem'}>
          {intl.formatMessage(messages.section)} {index + 1}{' '}
          {intl.formatMessage(messages.of)} {total}
        </Wrap>
        <Wrap
          flexWrap={'nowrap'}
          flexDir={'column'}
          width={'100%'}
          br={'1rem'}
          bgColor={white}
          borders={accentColorSecond}
          padding={'2rem'}
        >
          <StyledTransparentInput fs={'1.6rem'}>
            <Input
              placeholder={intl.formatMessage(messages.preText)}
              value={series.preText || ''}
              onChange={(e) =>
                editSection({
                  index,
                  section: { ...series, preText: e.value },
                })
              }
            />
          </StyledTransparentInput>
          <Wrap width={'100%'} justifyCont={'space-between'}>
            <Wrap width={'calc(100% - 16rem)'}>
              <StyledTransparentInput>
                <Input
                  required
                  value={series.name}
                  onChange={(e) =>
                    editSection({
                      index,
                      section: { ...series, name: e.value },
                    })
                  }
                />
              </StyledTransparentInput>
            </Wrap>
            <Wrap
              width={'9rem'}
              alignItems={'center'}
              justifyCont={'space-between'}
            >
              <Button
                icon
                transparent
                onClick={() => copySection({ seriesIdx: index })}
              >
                <CopyIcon color={accentColorPrim} width={'1.8rem'} />
              </Button>
              <Button
                icon
                transparent
                onClick={() => removeSection({ seriesIdx: index })}
              >
                <DeleteIcon color={red} width={'1.8rem'} />
              </Button>
              {/*              <Button icon transparent>
                <VDotsIcon color={accentColorPrim} height={'1.8rem'} />
              </Button>*/}
            </Wrap>
          </Wrap>
          <StyledTransparentInput fs={'1.6rem'} secondary>
            <Input
              placeholder={intl.formatMessage(messages.postText)}
              value={series.postText || ''}
              onChange={(e) =>
                editSection({
                  index,
                  section: { ...series, postText: e.value },
                })
              }
            />
          </StyledTransparentInput>
        </Wrap>
      </Wrap>
      <RightActions
        addSection={addSection}
        addQuestion={addQuestion}
        sectionIdx={index + 1}
        questionIdx={0}
      />
    </SectionWrap>
  );
};

export default memo(QuestionnaireSection);
